import { buildMetadata, type BuildMetadata } from '@/shared/build-metadata';
import { releaseContract, type ReleaseContract } from '@/shared/release-contract';

export type ReleaseManifest = Readonly<{
    revision: string;
    protocolVersion: number;
    minSupportedFrontendProtocolVersion: number;
}>;

export const createReleaseManifest = ({
    build = buildMetadata,
    contract = releaseContract,
}: {
    build?: BuildMetadata;
    contract?: ReleaseContract;
} = {}): ReleaseManifest => {
    return Object.freeze({
        revision: build.revision,
        protocolVersion: contract.protocolVersion,
        minSupportedFrontendProtocolVersion: contract.minSupportedFrontendProtocolVersion,
    });
};

export const releaseManifest = createReleaseManifest();
